import { Theme, createStyles } from '@material-ui/core'

const applicationCardStyles = ({ breakpoints, spacing }: Theme) =>
  createStyles({
    card: {
      width: '379px',
      //height: "379px",
      margin: '0px 15px 10px 0px',
      border: '1px solid #707070',
      borderRadius: '7px',
      boxShadow: '0px 3px 6px rgba(0,0,0,0.16)',
      fontFamily: 'Arial',
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'column' as const,
      position: 'relative' as const,
      alignSelf: 'stretch',
      [breakpoints.down('sm')]: {
        marginRight: '0px'
      }
    },
    flag: {
      position: 'relative' as const,
      display: 'flex',
      justifyContent: 'flex-end',
      color: '#fff',
      top: '1%'
    },
    status: {
      color: '#000',
      background: '#FBF6EE',
      padding: '0.1rem 0.6rem',
      lineHeight: '20px',
      alignSelf: 'flex-end',
      marginTop: '26px',
      position: 'absolute' as const,
      fontSize: '0.8rem',
      '&::before': {
        content: '""',
        position: 'absolute' as const,
        top: 0,
        left: '-14px',
        width: 0,
        height: 0,
        borderTop: '20px solid #FBF6EE',
        borderLeft: '15px solid transparent'
      },
      '&::after': {
        content: '""',
        position: 'absolute' as const,
        bottom: 0,
        left: '-14px',
        width: 0,
        height: 0,
        borderBottom: '20px solid #FBF6EE',
        borderLeft: '15px solid transparent'
      }
    },
    statusDisabled: {
      background: '#E8E8E8',
      '&::before': {
        borderTop: '20px solid #E8E8E8'
      },
      '&::after': {
        borderBottom: '20px solid #E8E8E8'
      }
    },
    statusManual: {
      background: '#189EB4',
      '&::before': {
        borderTop: '20px solid #189EB4'
      },
      '&::after': {
        borderBottom: '20px solid #189EB4'
      }
    },
    cardContent: {
      paddingTop: '24px',
      paddingLeft: '16px',
      '@media screen and (max-width: 400px)': {
        paddingLeft: '16px'
      }
    },
    list: {
      listStyleType: 'none',
      padding: '0',
      color: '#A2A4AF',
      fontSize: '20px',
      margin: '0',
      marginBottom: '16px'
    },
    listItem: {
      margin: '0'
    },
    cardApplicantName: {
      lineHeight: 'normal',
      '@media screen and (max-width: 599px)': {
        fontSize: '1.5rem'
      }
    },
    listItemText: {
      '@media screen and (max-width: 599px)': {
        fontSize: '1.05rem',
      },
    },
    applicantName: {
      fontSize: '2.5rem',
      [breakpoints.down('sm')]: {
        fontSize: '2rem'
      }
    },
    message: {
      color: '#fff',
      backgroundColor: '#5c6dce',
      padding: '0.5rem 0',
      textAlign: 'center' as const,
      margin: '0',
      maxHeight: 100,
      overflow: 'auto',
      marginBottom: '0.5rem'
    },
    createdDate: {
      color: '#868A98',
      marginBottom: '16px',
      '@media screen and (max-width: 599px)': {
        '@media screen and (min-width: 401px)': {
          fontSize: '0.9rem'
        }
      },
      '@media screen and (max-width: 400px)': {
        '@media screen and (min-width: 339px)': {
          fontSize: '0.8rem'
        }
      }
      // marginTop: "10px",
      // marginLeft: "10px",
      // position: "absolute" as "absolute",
    },
    guarantorGridItemFi: {
      zIndex: 1,
      lineHeight: '0.2px'
    },
    guarantorGridItemEn: {
      zIndex: 1,
      textAlign: 'center',
      marginTop: '-7px',
      lineHeight: '0.2px'
    },
    showingsPopupItem: {
      display: 'flex',
      '& p': {
        fontSize: '13px'
      }
    },
    popover: {
      pointerEvents: 'none' as const
    },
    paper: {
      padding: spacing(1)
    },
    line: {
      margin: '8px -24px',
      padding: '0',
      width: '100% + 48px',
      borderBottom: '1px solid #C3C6D1'
    },
    suggestContainer: {
      background: '#FBF6EE',
      padding: '25px 40px',
      display: 'flex',
      fontSize: '12px',
      borderRadius: '25px',
      maxWidth: '800px',
      [breakpoints.up('xs')]: {
        padding: '25px'
      },
      '& img': {
        marginRight: '10px'
      }
    },
    largeForm: {
      float: 'left',
      padding: '35px 0 15px 0',
      maxWidth: '800px',
      width: '100%',
      display: 'flex',
      [breakpoints.down('sm')]: {
        padding: '10px 0'
      },
      [breakpoints.up('lg')]: {
        display: 'flex',
        maxWidth: '800px'
      }
    },
    suggestDialogContainer: {
      display: 'flex',
      justifyContent: 'center'
    },
    buttonContainerClassName: {
      flex: '1 1 auto',
      margin: '10px 25px 25px 25px',
      display: 'flex',
      justifyContent: 'center'
    },
    buttonConfirmClassName: {
      width: '100%',
      textTransform: 'none',
      color: '#ffffff',
      backgroundColor: '#4f9b44',
      '&:hover': {
        backgroundColor: '#3f7c36'
      }
    },
    buttonCloseClassName: {
      boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.15)',
      width: '100%',
      textTransform: 'none',
      color: '#000000',
      '&:hover': {
        backgroundColor: '#d3d3d3'
      }
    },
    titlePopup: {
      textAlign: 'center',
      fontSize: '1.2rem'
    },
    dialogSaveBtn: {
      font: '13px CircularRegular',
      borderRadius: '10px',
      display: 'flex',
      justifyContent: 'center',
      textDecoration: 'none',
      padding: '15px 0',
      color: '#2f2f2f',
      boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.15)',
      textTransform: 'none' as const
    },
    modalTitle: {
      paddingTop: '5px',
      [breakpoints.down('sm')]: {
        fontSize: '1.2rem'
      }
    },
    primaryBtn: {
      font: '13px CircularRegular',
      borderRadius: '10px',
      display: 'flex',
      justifyContent: 'center',
      textDecoration: 'none',
      backgroundColor: '#4f9b44',
      padding: '15px 0',
      color: '#fff',
      marginBottom: '15px',
      '&:hover': {
        backgroundColor: '#3f7c36'
      }
    }
  })

export default applicationCardStyles
